import Box from '@mui/material/Box'
import {MPersonDetailGraphEntity} from 'app/modules/discovery/core/_models'
import {useStylesPersonsSearchResult} from 'styles/useStyles'
import FavoriteButton from '../FavoriteButton'
import PersonResult from '../PersonResult'

export default function PersonResultCard({
  person,
  scrollPosition,
  search,
  fromDir,
  fromProject,
  page,
  showFullPerson,
}: {
  person: MPersonDetailGraphEntity
  scrollPosition?: number
  search?: string
  fromDir?: boolean
  fromProject?: boolean
  page?: number
  showFullPerson?: (persId: string) => void
}) {
  const classes = useStylesPersonsSearchResult()
  return (
    <Box>
      <Box display={'flex'} justifyContent={'space-between'}>
        <PersonResult
          person={person}
          scrollPosition={scrollPosition ? scrollPosition : undefined}
          search={search ? search : undefined}
          fromDir={fromDir ? fromDir : undefined}
          page={page}
          fromProject={fromProject}
          showFullPerson={showFullPerson}
        />
        <Box display={'flex'}>
          <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'} gap={1}>
            <FavoriteButton item={person} type={'people'} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
